import { AxiosRequestConfig } from 'axios'

export interface MAUsParams {
  endDate: string
}

export interface MAUsData {
  count: number
}

export interface MAUsResponse {
  data: MAUsData
}

export interface UniqueCustomersParams {
  endDate: string
}

export interface UniqueCustomersResponse {
  data: {
    activeUsers: number
    totalBase: number
  }
}

const getMAUs = (params: MAUsParams): AxiosRequestConfig => ({
  url: '/dashboard/maus',
  method: 'GET',
  params,
})

const getUniqueCustomers = (params: UniqueCustomersParams): AxiosRequestConfig => ({
  url: '/dashboard/unique-customers',
  method: 'GET',
  params,
})

export { getMAUs, getUniqueCustomers }
